@if (step() === 1) {
<div class="flex flex-col gap-2 overflow-y-auto max-h-[65vh]">
  @for (deliveryNote of deliveryNotes(); track deliveryNote.id) {
  <div (click)="selectDeliveryNote(deliveryNote)" class="cursor-pointer">
    <soft-delivery-note-card [deliveryNote]="deliveryNote" />
  </div>
  }
</div>
} @if (step() === 2) { @if (isLoadingVehicles()) {
<soft-loading-spinner />
} @else {
<div class="flex flex-col gap-2 overflow-y-auto max-h-[65vh]">
  @for (vehicle of vehicles(); track vehicle.id) {
  <div
    (click)="selectVehicle(vehicle)"
    class="soft-card rounded-2xl flex items-center gap-3 hover:cursor-pointer hover:bg-hover p-3"
  >
    <soft-icon name="fa-regular fa-car" />
    <div class="flex flex-col">
      <span class="font-semibold">{{ vehicle.fahrzeug }}</span>
      <span class="text-sm text-light">{{ vehicle.bezeichnung }}</span>
    </div>
    <soft-icon class="ml-auto" name="fa-regular fa-chevron-right" />
  </div>
  }
</div>
} }
